import AbstractAsyncTablePage from '../abstract-async-table-page';
import WebReturnsSidebar from '../../components/web-returns/web-returns-sidebar';
import SearchForm from '../../model/search-form';
import Table from '../../components/shared/table';
import HTMLTemplateHelper from '../../helpers/html-template-helper';
import SalesOrderData from '../../model/sales-order-data';
import { formatCurrency } from '../../helpers/utils';
import ReturnsNotification from '../../components/common/returns-notification';

export default class WebReturnsOrders extends AbstractAsyncTablePage {
  protected readonly searchForm: SearchForm;
  protected readonly table: Table;
  protected readonly tableColumnDefinitions: DataTables.ColumnDefsSettings[] = [
    { targets: 0, data: (data: SalesOrderData): string => `<a href="${window.ACC.config.encodedContextPath}/webreturns/orders/details/${data.orderId}">${data.orderId}</a>` }, // eslint-disable-line max-len
    { targets: 1, data: 'externalId' },
    { targets: 2, data: 'status' },
    {
      targets: 3,
      data: (data: SalesOrderData, type: string): string | number => {
        if (type === 'sort') {
          return data.voucherDate;
        }

        return data.orderDate;
      },
    },
    { targets: 4, data: 'netAmount', className: 'text-align-right' },
    {
      targets: 5,
      data: (data: SalesOrderData): string | null => (data.addToCart ? HTMLTemplateHelper.createLinkButton({
        buttonClass: '-clear -compact',
        href: `${window.ACC.config.encodedContextPath}/newReturns/order/${data.orderId}/addOrder`,
        text: 'Add to cart',
        textClass: 'sr-only',
        icon: 'fas fa-shopping-cart',
      }).outerHTML : null),
      className: 'text-align-center',
    },
  ];

  private readonly totalAmount: JQuery;

  constructor(private readonly body: JQuery) {
    super();

    this.searchForm = new WebReturnsSidebar(this.body.find('.js-searchForm') as JQuery<HTMLFormElement>);
    this.table = new Table(body.find('.js-table'), this.tableColumnDefinitions);
    this.totalAmount = body.find('.js-tableSumValue');

    ReturnsNotification.initAll();
    this.bindAsyncData();
  }

  protected setRows(data: SalesOrderData[]): void {
    super.setRows(data);
    const total = data.reduce((sum, salesOrder) => sum + salesOrder.netAmount ?? 0, 0);
    this.totalAmount.text(formatCurrency(total));
  }
}
